import { render, staticRenderFns } from "./EditableCheckboxesOptions.vue?vue&type=template&id=5055cc52&"
import script from "./EditableCheckboxesOptions.vue?vue&type=script&lang=js&"
export * from "./EditableCheckboxesOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports